import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Button, Form, Input, Steps } from 'antd';
import { useTranslation } from 'react-i18next';
import { socketEmitEvent } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import classNames from 'classnames';
import regex from '../../constants/system.keys';

const { Step } = Steps;

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const UpdateStreamComponent = ({ data, onCancel }) => {
  const dispatch = useDispatch();
  /**
   * @param step
   * @type step: 0:scan link, 1:required auth, 2: update camera
   */
  useEffect(() => {
    return () => {
      setCounter(null);
      setUpdateReturn(null);
      clearInterval(refHandleTimer.current);
      setHandleScan({ loading: false, step: 0, data: null });
    };
  }, [data]);
  const [isBlock, setIsBlock] = useState(false);
  const [requestId, setRequestId] = useState();
  const [handleScan, setHandleScan] = useState({
    loading: false,
    step: 0,
    data: null,
  });
  const [counter, setCounter] = useState(0);
  const [serial, setSerial] = useState(null);

  const { checkRtspStreamReturn, updateDevice, namespace } = useSelector(
    (state) => state,
  );
  const [requestHandle, setRequestHandle] = useState({
    step: 0,
    requestId: null,
  });
  const [handleTimer, setHandleTimer] = useState();
  const { t } = useTranslation();
  const refHandleTimer = useRef();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [updateReturn, setUpdateReturn] = useState();
  const [soureLink, setSourceLink] = useState();
  const [gatewaySerial, setGatewaySerial] = useState();
  useEffect(() => {
    forceUpdate({});
  }, []);

  useEffect(() => {
    if (form && data) {
      const { gatewaySerial, serial } = data;
      setGatewaySerial(gatewaySerial);
      setSerial(serial);
    }
    return () => {
      form.resetFields();
    };
  }, [data, form]);

  useEffect(() => {
    setRequestId(new Date().getTime());
    return () => {
      setIsBlock(false);
      setHandleScan({
        loading: false,
        step: 0,
        data: null,
      });
      setCounter(0);
      setRequestId(null);
      setRequestHandle({
        step: 0,
        requestId: null,
      });
      setUpdateReturn(null);
    };
  }, []);

  useEffect(() => {
    if (updateDevice?.requestId === requestHandle?.requestId) {
      setUpdateReturn(updateDevice);
    }
  }, [requestHandle, updateDevice]);

  useEffect(() => { }, [counter]);
  useEffect(() => {
    if (checkRtspStreamReturn?.result === 1) {
      setCounter((state) => state + 1);
    }
  }, [checkRtspStreamReturn]);

  useEffect(() => {
    if (checkRtspStreamReturn?.requestId === requestHandle?.requestId) {
      clearInterval(refHandleTimer.current);
      if (checkRtspStreamReturn?.result === 1) {
        form.setFields([
          {
            name: 'source',
            errors: [],
          },
        ]);
        setHandleScan({
          loading: false,
          step:
            checkRtspStreamReturn?.data[0]?.authenticationRtsp === 'require'
              ? 1
              : 2,
          data: {
            ...checkRtspStreamReturn.data[0],
            isShowFormUpdate: false,
            loading: false,
          },
        });
        if (
          requestHandle.step === 1 &&
          checkRtspStreamReturn.data[0].authenticationRtsp === 'require' &&
          counter > 1
        ) {
          setCounter((state) => state - 1);
          form.setFields([
            {
              name: 'password',
              errors: [t('Username of password is incorrect!')],
            },
            {
              name: 'source',
              errors: [],
            },
          ]);
        }
      } else {
        setHandleScan({ loading: false, step: 0, data: null });
        form.setFields([
          {
            name: 'source',
            errors: [t('Device not found, check again!')],
          },
        ]);
      }
    }
  }, [checkRtspStreamReturn, counter, form, t]);

  useEffect(() => {
    if (handleTimer === 0) {
      setHandleScan((state) => ({ ...state, loading: false }));
      clearInterval(refHandleTimer.current);
      form.setFields([
        {
          name: 'source',
          errors: [t('Timeout, can not find video source stream!')],
        },
      ]);
    }
  }, [form, handleTimer, t]);

  const handleBack = () => {
    form.resetFields();
    setCounter(0);
    setHandleScan({
      step: 0,
      loading: false,
      data: null,
    });
    setRequestHandle({ requestId: null, step: 0 });
  };

  const onFinish = useCallback(
    (values) => {
      setHandleScan((state) => ({
        ...state,
        loading: true,
      }));
      setHandleTimer(30);
      refHandleTimer.current = setInterval(() => {
        setHandleTimer((timer) => timer - 1);
      }, 1000);
      setSourceLink(values.source);
      var { source, username, password } = values;

      if (handleScan.step === 1) {
        source = soureLink;
      }
      const timeRequest = new Date().getTime();
      setRequestId(timeRequest);
      setRequestHandle({
        step: username && password ? 1 : 0,
        requestId: timeRequest,
      });
      let data = {
        source,
        username,
        password,
        namespace,
        gatewaySerial,
      };
      console.log('🚀 ~ CHECK_RTSP_STREAM ~ data:', data);
      let dataObj = {
        appServiceType: SERVICE.CHECK_RTSP_STREAM,
        requestId: timeRequest,
        body: JSON.stringify(data),
      };

      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, requestId, handleScan, soureLink],
  );

  const updateStream = useCallback(
    (values) => {
      const { source, username, password } = values;
      let data = {
        source,
        username,
        password,
        namespace,
        serial,
        thumbnail: checkRtspStreamReturn?.data[0]?.thumbnail,
        typeCamera: checkRtspStreamReturn?.data[0]?.typeCamera,
        factorySerial: checkRtspStreamReturn?.data[0]?.factorySerial,
        localAddress: checkRtspStreamReturn?.data[0]?.localAddress,
      };
      console.log('🚀 ~ UPDATE_CAMERA_INFO ~ data:', data);
      const timeRequest = new Date().getTime();
      setRequestId(timeRequest);
      let dataObj = {
        appServiceType: SERVICE.UPDATE_CAMERA_INFO,
        requestId: timeRequest,
        body: JSON.stringify(data),
      };
      setCounter(0);
      onCancel();
      handleBack();
      return dispatch(socketEmitEvent(dataObj));
    },
    [data, dispatch, namespace, requestId, handleScan],
  );

  const renderButtonStep = useMemo(() => {
    return handleScan?.step < 2 ? (
      <Form.Item shouldUpdate={true}>
        <Button type="primary" loading={handleScan.loading} htmlType="submit">
          {t('Check')}
        </Button>
      </Form.Item>
    ) : (
      <Button
        loading={handleScan.loading}
        onClick={() => {
          updateStream({
            source: checkRtspStreamReturn?.data[0]?.source,
            username: checkRtspStreamReturn?.data[0]?.username,
            password: checkRtspStreamReturn?.data[0]?.password,
          });
        }}
      >
        {t('Update')}
      </Button>
    );
  }, [handleScan]);
  return (
    <div className="rstp-link-add-camera-component">
      <div className="steps-add-camera">
        <Steps size="small" current={handleScan?.step}>
          <Step title={t('Check')} />
          <Step title={t('Validate')} />
          <Step title={t('Update')} />
        </Steps>
      </div>
      {handleScan.step === 0 && (
        <div className="guidelines-add-camera">
          <div className="title">{t('Functional support cases')}</div>
          <ul>
            <li>{t('The public camera supports data access via RTSP')}</li>
            <li>{t('Streaming is extracted from traditional receivers')}</li>
            <li>{t('Source re-stream from existing VMS systems')}</li>
          </ul>
        </div>
      )}
      {handleScan.step === 1 && (
        <div className="guidelines-add-camera">
          <div className="title">{t('Streaming requires authentication')}</div>
        </div>
      )}

      <div className="validate-rtsp-form">
        <Form
          form={form}
          name="validate-form"
          layout={handleScan.step === 0 ? 'inline' : 'horizontal'}
          onFinish={onFinish}
        >
          {handleScan.step === 0 && (
            <Form.Item
              name="source"
              rules={[
                {
                  required: true,
                  message: t('Please input rtsp link!'),
                },
                {
                  pattern: regex.isurl,
                  message: t('Please input rtsp link!'),
                },
                {
                  max: 200,
                  message: t('Please input up to 200 characters!'),
                },
              ]}
            >
              <Input
                disabled={handleScan.step === 1}
                placeholder={'rtsp://host:port/path'}
              />
            </Form.Item>
          )}

          {handleScan.step === 1 && (
            <Fragment>
              <Form.Item
                name="source"
                label={t('Source')}
                rules={[
                  {
                    required: true,
                    message: t('Please input the source!'),
                  },
                  {
                    pattern: regex.isurl,
                    message: t('Please input the source!'),
                  },
                  {
                    max: 200,
                    message: t('Please input up to 200 characters!'),
                  },
                ]}
              >
                <Input
                  disabled
                  placeholder={t('Source')}
                  className="source_validate"
                />
              </Form.Item>
              <Form.Item
                name="username"
                label={t('Username')}
                rules={[
                  {
                    required: true,
                    message: t('Please input the username!'),
                  },
                  {
                    pattern: regex.isName,
                    message: t('Please enter only letters and numbers!'),
                  },
                  {
                    max: 80,
                    message: t('Please input up to 80 characters!'),
                  },
                ]}
              >
                <Input placeholder={t('Username')} />
              </Form.Item>
              <Form.Item
                name="password"
                label={t('Password')}
                rules={[
                  {
                    required: true,
                    message: t('Please input the password!'),
                  },
                  {
                    pattern: regex.isPassword,
                    message: t('Please input the password!'),
                  },
                  {
                    max: 80,
                    message: t('Please input up to 80 characters!'),
                  },
                ]}
              >
                <Input
                  type="password"
                  className="password_validate"
                  placeholder={t('Password')}
                />
              </Form.Item>
            </Fragment>
          )}
          {handleScan.step === 2 && (
            <Fragment>
              <Form.Item name="sourceUpdate">
                <Input
                  defaultValue={checkRtspStreamReturn?.data[0]?.source}
                  disabled
                />
              </Form.Item>

              <Form.Item name="usernameUpdate">
                <Input
                  defaultValue={checkRtspStreamReturn?.data[0]?.username}
                  disabled
                />
              </Form.Item>
              <Form.Item name="passwordUpdate">
                <Input
                  defaultValue={checkRtspStreamReturn?.data[0]?.password}
                  disabled
                />
              </Form.Item>
            </Fragment>
          )}
          <div
            className={classNames('validate-btn', {
              couple: handleScan.step === 1,
            })}
          >
            {handleScan.step === 1 && (
              <Button onClick={handleBack}>{t('Back')}</Button>
            )}

            {renderButtonStep}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default UpdateStreamComponent;
